module.exports = __webpack_public_path__ + "media/placeholders/placeholder-new-28812104.jpg";